<style scoped lang="scss" type="text/scss">

</style>

<template>
    <div class="global-relative">
        <loading-placeholder :loading="requesting"></loading-placeholder>
        <el-table :data="registrableCompetitions" stripe border size="small" style="width: 100%">
            <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
            <el-table-column prop="name" label="赛事名称" align="center" min-width="120"></el-table-column>
            <el-table-column prop="year_text" label="赛事年份" align="center" min-width="50"></el-table-column>
            <el-table-column prop="theme" label="赛事主题" align="center" min-width="60"></el-table-column>
            <el-table-column prop="venue_full_name" label="举办地址" align="center" min-width="120"></el-table-column>
            <el-table-column prop="registration_deadline_text" label="报名截止时间" align="center"
                             min-width="50"></el-table-column>
            <el-table-column prop="start_time_text" label="比赛开始时间" align="center"
                             min-width="50"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {handleCompetitions} from '../../../../utils/data-handler';

    export default {
        name: '',
        data () {
            return {
                visible: false,
                competition: null,
                requesting: false
            };
        },
        created () {
            this.loadRegistrableCompetitions();
        },
        computed: {
            registrableCompetitions () {
                const registrableCompetitions = this.$store.state.competition.registrableCompetitions;
                return handleCompetitions(registrableCompetitions);
            }
        },
        methods: {
            loadRegistrableCompetitions () {
                this.$normalRequest('competition/loadRegistrableCompetitions', null, false, false, this, 'requesting').then();
            }
        }
    };
</script>
